module.exports = __webpack_public_path__ + "static/media/arrow-purple-right.96b0bc7e.svg";